import {View} from 'react-native'

import {type FeedPostSliceItem} from '#/state/queries/post-feed'
import {type VideoFeedSourceContext} from '#/screens/VideoFeed/types'
import {atoms as a, useBreakpoints, useGutters} from '#/alf'
import {CapsulePostCard} from '#/components/capsules/CapsulePostCard'
import * as Grid from '#/components/Grid'
import {VideoPostCardPlaceholder} from '#/components/VideoPostCard'

export function PostFeedCapsuleGridRow({
  items: slices,
  sourceContext,
}: {
  items: FeedPostSliceItem[]
  sourceContext: VideoFeedSourceContext
}) {
  const gutters = useGutters(['base', 'base', 0, 'base'])
  const {gtMobile} = useBreakpoints()

  return (
    <View style={[gutters]}>
      <View style={[a.flex_row, a.gap_sm]}>
        <Grid.Row gap={a.gap_sm.gap}>
          {slices.map(slice => (
            <Grid.Col key={slice.post.uri} width={gtMobile ? 1 / 3 : 1 / 2}>
              <CapsulePostCard
                capsulePost={slice.post}
                capsule={slice.capsule}
                sourceContext={sourceContext}
                moderation={slice.moderation}
              />
            </Grid.Col>
          ))}
        </Grid.Row>
      </View>
    </View>
  )
}

export function PostFeedCapsuleGridRowPlaceholder() {
  const gutters = useGutters(['base', 'base', 0, 'base'])
  return (
    <View style={[gutters]}>
      <View style={[a.flex_row, a.gap_sm]}>
        <VideoPostCardPlaceholder />
        <VideoPostCardPlaceholder />
      </View>
    </View>
  )
}
